export const timeline_fake = require('../fakeData/timeline_fake.json');
export const getChoice_fake = require('../fakeData/getChoice_fake.json');
export const generateChoice_fake = require('../fakeData/generateChoice_fake.json');
export const deliveryInformationsRef_fake = require('../fakeData/deliveryInformationRef_fake.json');
export const claimResponseFakeData = require('../fakeData/claimResponse_fake.json');
export const oneClaimFakeData = require('../fakeData/oneClaimFakeData_fake.json');
export const roundInfoFakeData = require('../fakeData/roundInfo_fake.json');
export const parcel_timeline_fake = require('../fakeData/parcel_timeline_fake.json');